import { CDN_URL } from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/demo-data-button/constants';
import type {
    LoadedTfliteFaceModels,
    TfliteGlobal,
} from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/providers/face-detector-provider/types';

/** Relative CDN paths — also reported in liveness-batch `model_versions`. */
export const FACE_DETECTOR_MODEL_PATH = 'models/v4/face_detector.tflite';
export const FACE_LANDMARKS_MODEL_PATH = 'models/v4/face_landmarks_detector.tflite';
export const IQA_BLUR_MODEL_PATH = 'models/v3/iqa_mobilenetv3small100_sigmoid.tflite';

/**
 * Loads face detector, landmark, and image-quality TFLite models via `window.tflite`.
 * Caller should ensure tfjs + tf-tflite scripts are on the page (or poll until `window.tflite` exists).
 */
export async function fetchTfliteFaceModels(): Promise<LoadedTfliteFaceModels> {
    if (typeof window === 'undefined') {
        throw new Error('fetchTfliteFaceModels must run in a browser');
    }

    const { tflite } = window as TfliteGlobal;

    if (!tflite?.loadTFLiteModel) {
        throw new Error('window.tflite is not available');
    }

    const [detectorModel, landmarkModel, imageQualityModel] = await Promise.all([
        tflite.loadTFLiteModel(`${CDN_URL}/${FACE_DETECTOR_MODEL_PATH}`),
        tflite.loadTFLiteModel(`${CDN_URL}/${FACE_LANDMARKS_MODEL_PATH}`),
        tflite.loadTFLiteModel(`${CDN_URL}/${IQA_BLUR_MODEL_PATH}`),
    ]);

    return { detectorModel, landmarkModel, imageQualityModel };
}
